import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { _Api } from "../common/api/_call";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

/** First tab on Collection list: full catalog via `api/v1/POS/catalog/list` (same as Create your own). */
export const CATALOG_ALL_NAV_ID = '__catalog_all__';

/** Tabs with subcategory dropdown + `itemData` product grid. */
export const CATALOG_ITEM_NAV_ID = 'Item';
export const CATALOG_COLLECTION_NAV_ID = 'Collection';
export const CATALOG_STYLE_NAV_ID = 'Style';

export const CATALOG_SUBCATEGORY_NAV_IDS = [
  CATALOG_ITEM_NAV_ID,
  CATALOG_COLLECTION_NAV_ID,
  CATALOG_STYLE_NAV_ID,
];

const CatalogNavbar = (props) => {
    const { t } = useTranslation();
    const generalsettings = useSelector((state) => state.app.generalsettings)
    const {
        setNavid,
        navid,
        location,
        setproductNavid,
        pNavid,
        prependAllMenu,
    } = props;
    const catelogMenuReload = JSON.parse(localStorage.getItem('catelogMenuReload'));
    const [collectionmenu, setCollectionmenu] = useState(catelogMenuReload?.length ? catelogMenuReload : []);
    const [defaultfirst, setDefaultfirst] = useState();
    const [active, setActive] = useState(false);
    const navidRef = useRef(navid);
    navidRef.current = navid;

    const tabsMenu = useMemo(() => {
        const base = Array.isArray(collectionmenu) ? collectionmenu : [];
        if (!prependAllMenu) return base;
        return [{ id: CATALOG_ALL_NAV_ID, name: 'All' }, ...base];
    }, [prependAllMenu, collectionmenu]);

    const fetchCatalogMenu = useCallback(async () => {
        try {
            const postdata = {}
            let res = await _Api(postdata, `api/v1/POS/common/catelogMenu`);
            if (res.code === 200) {
                localStorage.setItem('catelogMenuReload', JSON.stringify(res.data));
                setCollectionmenu(res.data);
                const firstApiId = res.data?.length ? res.data[0]?.id : '';
                const defaultId = prependAllMenu ? CATALOG_ALL_NAV_ID : firstApiId;
                if (!navidRef.current) {
                    if (!location) {
                        setNavid(defaultId);
                    }
                    setDefaultfirst(defaultId);
                }
            }
        }
        catch (err) {
            console.log(err, "err");
        }
    }, [location, setNavid, prependAllMenu]);

    useEffect(() => {
        fetchCatalogMenu();
    }, [fetchCatalogMenu]);

    return (
        <>
            <ul className='catalog-area-header-area-tabs' role="tablist">
                {tabsMenu?.length ? tabsMenu.map((result, key) => {
                    return (
                        <li className='catalog-area-header-area-tabs-single' key={`${result?.id}-${key}`} >
                            {
                                location === '/app/pos/products' || location === "/app/pos/CatalogDiamond" ?
                                    <button onClick={() => { setActive(false); setproductNavid(result?.id); }} className={active ? "nav-link" : (pNavid || navid || defaultfirst) === result?.id ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#jalwary" type="button" role="tab" >{t(result.name)}</button>
                                    :
                                    <button onClick={() => { setActive(false); setNavid(result?.id); }} className={(navid || defaultfirst) === result?.id ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#jalwary" type="button" role="tab" >{t(result.name)}</button>
                            }
                        </li>
                    )
                }) : ""}
                <li className={generalsettings?.data?.generalsetup?.productChoice === '1' ? 'catalog-area-header-area-tabs-single' : "d-none"} onClick={() => { setActive(true) }}>
                    <Link to="/app/pos/products/CatalogDiamond" className={active ? "nav-link active" : "nav-link"} type="button" role="tab" >{t("Diamond")}</Link>
                </li>

            </ul>
        </>
    )
}
export default CatalogNavbar;
